import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/** Requests the apps for one zone, including explicit refreshes. */
export function getActionsConfig() {
  return {
    get: store.actions.request({
      input: store.actions.Data.asIs<ents.core.admin.Context.ForZone>(),
      output: store.actions.Data.asIs<readonly ents.core.admin.App.ForUser[]>(),
      reducers: {
        request: ({ state, data: { zoneId } }) => ({
          ...state,
          lookup: { ...state.lookup, [zoneId]: { isLoading: true } },
        }),
        success: ({ state, data: { request, response } }) => ({
          ...state,
          lookup: { ...state.lookup, [request.zoneId]: { data: response } },
        }),
        error: ({ state, data: { request, error } }) => ({
          ...state,
          lookup: { ...state.lookup, [request.zoneId]: { error } },
        }),
        cancellation: ({ state, data: { request } }) => ({
          ...state,
          lookup: { ...state.lookup, [request.zoneId]: undefined },
        }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
